<template>
    <div>
        <b-skeleton
                height="1.563rem"
                class="mb-3"
        />
        <b-row>
            <b-col class="px-0 px-md-3">
                <b-skeleton-img
                        :height="isMobile ? '16.25rem' : '25.625rem'"
                        no-aspect
                />
            </b-col>
        </b-row>
        <b-container class="mx-auto property-details-container">
            <b-row>
                <b-col
                        class="mt-2 mt-md-4 mb-4 col-xxl-8"
                        cols="12"
                        lg="8"
                >
                    <b-skeleton height="5.563rem" />
                    <b-row>
                        <b-col class="mt-4">
                            <b-skeleton height="23.188rem" />
                        </b-col>
                    </b-row>
                </b-col>
                <b-col
                        v-if="isDesktop"
                        class="details-actions-col mt-lg-4 mb-lg-4"
                        cols="4"
                >
                    <b-skeleton height="23.188rem" />
                </b-col>
            </b-row>
        </b-container>
    </div>
</template>

<script>
    import IsMobileMixin from "@milestoneslabs/milestones-ui-kit/src/mixins/IsMobileMixin";

    export default {
        name: 'PropertyDetailsLoading',
        mixins: [
            IsMobileMixin,
        ]
    };
</script>